import React, { useState, useEffect, useRef, useContext } from "react";
import styles from "./PackageDetail.module.css";
import IndicatorLabel from "../IndicatorLabel/IndicatorLabel";
import df from "../../utils/dateFormater";
import { TiDocumentText } from "react-icons/ti";
import PersonIcon from "@material-ui/icons/Person";
import { Tooltip } from "@material-ui/core";
import chemicalImg from "../../assets/images/QUIMICO.svg";
import materialImg from "../../components/NavBar/Menu/icons/INSTRUMENTS.svg";
import washerIcon from "../../assets/images/purpleWashing.svg";

import { CiTimer } from "react-icons/ci";
import t from "../../utils/translation";
import { IoBookOutline, IoReload } from "react-icons/io5";
import { FaTemperatureHigh } from "react-icons/fa";
import request from "../../utils/request";
import ImageModal from "../ImageModal/ImageModal";
import ButtonQ from "../ButtonQ";
import ReportModal from "../ReportModal/ReportModal";
import ModalLoading from "../ModalLoading/ModalLoading";
import LocalizationContext from "../../utils/LocalizationContext";
import Redirect from "../../utils/Redirect";
import PageContainer from "../PageContainer/PageContainer";
import hasPositive from "../../utils/hasPositive";

import toStartIcon from "../../assets/images/Washing/Icono To startPurple.svg";
import inProgressIcon from "../../assets/images/Washing/Icono In progressPurple.svg";
import finishedIcon from "../../assets/images/Washing/Icono FinishedPurple.svg";
import * as htmlToImage from 'html-to-image';
import jsPDF from "jspdf";
import ObservationCard from "../ObservationCard/ObservationCard";


export default function WashRecordDetail({ params, location }) {
  const [isModalOpen, setModalOpen] = useState(false);
  const [openSections, setOpenSections] = useState({});
  const [report, setReport] = useState({});
  const [showReport, setShowReport] = useState(false);
  const [cycleDetail, setCycleDetail] = useState(false);
  const [modalLoading, setModalLoading] = useState(false);
  const [showIconTerra, setShowIconTerra] = useState(false);
  const locale = useContext(LocalizationContext);

  const { cycleId } = params;
  const { state } = location;

  const handleImageClick = () => {
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  const handleCloseModalReport = () => {
    setShowReport(false);
    setShowIconTerra(false)
  };

 const generatePDF = async () => {
    setShowIconTerra(true)
    const marginTop = 10;
    const marginBottom = 10;
    if (!cycleDetail || !cycleDetail.packagesWashing) return;

    let allSections = {};
    cycleDetail.packagesWashing.forEach(pkg => {
        allSections[pkg.packageWashing.id] = true;
    });

    setOpenSections(allSections);

    await new Promise(resolve => setTimeout(resolve, 500));

    const element = document.getElementById('report-content');

    try {
        const dataUrl = await htmlToImage.toJpeg(element, {
            quality: 1,
            backgroundColor: 'white',
            useCORS: true
        });

        const img = new Image();
        img.src = dataUrl;

        img.onload = function () {
          const imgWidth = 210 - 20;  // Reducimos el ancho para el padding (10mm en cada lado)
          const pageHeight = 297 - 20;  // Reducimos la altura para el 

            const imgRatio = img.width / img.height;
            const imgHeight = imgWidth / imgRatio; 

            const pdf = new jsPDF({
                orientation: imgHeight > pageHeight ? 'portrait' : 'portrait',
                unit: 'mm',
                format: 'a4'
            });

            let y = 0;
            while (y < img.height) {
                const canvas = document.createElement('canvas');
                const ctx = canvas.getContext('2d');
                canvas.width = img.width;
                canvas.height = pageHeight * (img.width / imgWidth); 
                
                ctx.fillStyle = 'white';
                ctx.fillRect(0, 0, canvas.width, canvas.height);
                const offsetX = (canvas.width - img.width) / 2;

                ctx.drawImage(img, offsetX, -y, img.width, img.height);

                const chunkDataUrl = canvas.toDataURL('image/jpeg', 1.0);

                if (y > 0) pdf.addPage();
                pdf.addImage(chunkDataUrl, 'JPEG', 10, 10, imgWidth, pageHeight);

                y += canvas.height;
            }

            pdf.save('report.pdf'); 
        };
    } catch (error) {
        console.error('Error al generar el PDF:', error);
    } finally {
      setShowIconTerra(false)
    }
  }

  const getLoadDetail = async () => {
    setModalLoading(true);
    try {
      await request()
        .get(`/api/chargeWashing/chargeWashingDto?chargeWashingId=${cycleId}`)
        .then((response) => {
          const data = response.data;
          setCycleDetail(data);
        });
    } catch {
    } finally {
      setModalLoading(false);
    }
  };

  const downloadPdf = (cycleId) => {
    setModalLoading(true);
    request()
      .get(`/api/REPORT/batchrecordreportwithcode?chargeId=${cycleId}`)
      .then((response) => {
        const reportData = response.data;
        setReport(reportData);
        setShowReport(true);
      })
      .catch((error) => {
        console.error("Error al descargar el PDF:", error);
      })
      .finally(() => {
        setModalLoading(false);
      });
  };

 const status = (value) => {
    return value === 2
      ? t("ToStartSpan", locale) || "To Start"
      : value === 3
      ? t("StartedSpan", locale) || "Started"
      : value === 9 
      ? t("ReleaseSpan", locale) || "Release"
      : t("FinishedSpan", locale) || "Finished"
  };

  const findImg = (value) => {
    return value === 2
      ? toStartIcon
      : value === 3
      ? inProgressIcon
      : finishedIcon;
  };

  useEffect(() => {
    getLoadDetail();
  }, []);

  return (
    <PageContainer
      categoryId={2}
      category={t("WashingSpan")}
      backUrl={"/appwashingrecord"}
      title={t("BatchRecordSpan")}
      subtitle={t("DetailSpan")}
      clickBack={true}
      onClickBack={() =>
        Redirect({
          redirect: true,
          path: state?.hygieneRecord
            ? `/appmanagehygienemonitoring`
            : state?.cycleRecord
            ? `/appwashingrecord`
            : state?.materialRecord 
            ? `/appmaterialtracking` 
            : `/appmanagewashcycle`,

          parameters: {
            cycleId: !state?.cycleRecord ? cycleId : null,
            hygieneId: state?.hygieneId ?? null,
          },
        })
      }
    >
      <div className={styles.container} id="report-content">
      {showIconTerra && (
      <div className={styles.imageContainer}>
        <img
        className={styles.iconTerra}
        src={"/../../images/logotipoverde.png"}
        />
      </div>
      )}
        <ModalLoading open={modalLoading} />
        <div className={styles.header}>
          <div className={styles.headerTitleContainer}>
            <p
              className={styles.title}
              // onClick={() => handleCycleRecordDetail(cycleDetail.chargeWashingId)}
            >
              {cycleDetail.chargeStatus === 4 && (
                <Tooltip
                  title={
                    <span>{`${
                      hasPositive(cycleDetail.indicators)
                        ? t("BlankEntry18")
                        : t("BlankEntry19")
                    }`}</span>
                  }
                  arrow
                >
                  <div
                    className={`${styles.hasPositive} ${
                      hasPositive(cycleDetail.indicatorsWashing)
                        ? styles.red
                        : cycleDetail.indicatorsWashing.some(
                            (i) => !i.readingBi && !i.readingCheWasher
                          )
                        ? styles.gray
                        : styles.green
                    }`}
                  ></div>
                </Tooltip>
              )}
              {`${t("CycleNumberSpan", locale) || "Cycle Number"}: ${
                cycleDetail.cicle ?? ""
              }`}
            </p>

            <div className={styles.detailItem}>
              <div className={styles.detailItem} style={{ gap: "10px" }}>
                <img
                  className={styles.iconImg}
                  alt={status(cycleDetail.chargeStatus)}
                  src={findImg(cycleDetail.chargeStatus)}
                />
                <span className={styles.infoStatus}>
                  {status(cycleDetail.chargeStatus)}
                </span>
              </div>
            </div>
          </div>

          <div className={styles.sterilizerContainerInfo}>
            <img
              className={styles.iconSterilizer}
              src={washerIcon}
              alt="washer icon"
            />
            <p className={styles.sectionSubTitle}>
              {cycleDetail.washerName} - {cycleDetail.methodName}
            </p>
          </div>
          <div className={styles.headerDetails}>
            <div>
              <div className={styles.detailItem}>
                <IoReload className={styles.iconStyle} />
                <p className={styles.detailText}>
                  {t("StartedSpan") || "Started"}:{" "}
                  <span className={styles.info}>
                    {df(cycleDetail.cicleStartDate, "dateTime")}
                  </span>
                </p>
              </div>
              <div className={styles.detailItem}>
                <IoReload className={styles.iconStyle} />
                <p className={styles.detailText}>
                  {t("FinishedSpan") || "Finished"}:{" "}
                  <span className={styles.info}>
                    {df(cycleDetail.cicleFinishDate, "dateTime")}
                  </span>
                </p>
              </div>
            </div>

            <div>
              <div className={styles.detailItem}>
                <PersonIcon className={styles.iconStyle} />
                <p className={styles.detailText}>
                  {t("OperatorSpan") || "User"}:{" "}
                  <span className={styles.info}>{cycleDetail.operator}</span>
                </p>
              </div>
              <div className={styles.detailItem}>
                <TiDocumentText className={styles.iconStyle} />
                <p className={styles.detailText}>
                  {t("UsedProgramSpan") || "Used Program"}:{" "}
                  <span className={styles.info}>{cycleDetail.usedProgram}</span>
                </p>
              </div>
            </div>

            <div>
              <div className={styles.detailItem}>
                <FaTemperatureHigh className={styles.iconStyle} />
                <p className={styles.detailText}>
                  {t("TemperatureSpan") || "Temperature"}:{" "}
                  <span className={styles.info}>
                    {cycleDetail.temperature &&
                      cycleDetail.temperature +
                        " " +
                        cycleDetail.temperatureUnit}
                  </span>
                </p>
              </div>
              <div className={styles.detailItem}>
                <CiTimer className={styles.iconStyle} />
                <p className={styles.detailText}>
                  {t("TimeSpan") || "Time"}:{" "}
                  <span className={styles.info}>
                    {cycleDetail.washingTime &&
                      cycleDetail.washingTime + " " + cycleDetail.timeUnit}
                  </span>
                </p>
              </div>
            </div>

            <div>
              <div className={styles.detailItem}>
                <IoBookOutline className={styles.iconStyle} />
                <p className={styles.detailText}>
                  {t("DetergentTypeSpan", locale) || "Detergent Type"}:{" "}
                  <span className={styles.info}>
                    {cycleDetail.detergentTypeDescription}
                  </span>
                </p>
              </div>
              <div className={styles.detailItem}>
                <IoBookOutline className={styles.iconStyle} />
                <p className={styles.detailText}>
                  {t("DetergentConcentrationSpan", locale) ||
                    "Detergent Concentration"}
                  :{" "}
                  <span className={styles.info}>
                    {cycleDetail.detergentConcentration}
                  </span>
                </p>
              </div>
            </div>

            <div>
              <div className={styles.detailItem}>
                <IoBookOutline className={styles.iconStyle} />
                <p className={styles.detailText}>
                  {t("WaterPressureSpan", locale) || "Water Pressure"}:{" "}
                  <span className={styles.info}>
                    {cycleDetail.waterPressure}
                  </span>
                </p>
              </div>
              <div className={styles.detailItem}>
                <IoBookOutline className={styles.iconStyle} />
                <p className={styles.detailText}>
                  {t("WaterHardnessSpan", locale) || "Water Hardness"}:{" "}
                  <span className={styles.info}>
                    {cycleDetail.waterHardness}
                  </span>
                </p>
              </div>
            </div>
          </div>

         <ObservationCard
            chargeMovements={cycleDetail.chargeMovements}
            cycleMovements={cycleDetail.cycleMovements}
          />
        </div>
    
        <div className={styles.containerAbajo}>
          <div className={styles.containerLeft}>
            <section className={styles.section}>
              <h2 className={styles.sectionTitle}>{t("IndicatorSpan")}</h2>

              <div className={styles.imageTitleContainer}>
                <img
                  src={chemicalImg}
                  alt="chemicalIndicator"
                  className={styles.image}
                />
                <h2 className={styles.sectionSubTitle}>
                  {" "}
                  {t("ChemicalIndicatorSpan")}
                </h2>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  gap: "10px",
                }}
              >
                <div className={styles.indicatorGeneral}>
                  {cycleDetail.indicatorsWashing &&
                  cycleDetail.indicatorsWashing.filter(
                    (i) => !i.indicator.name.toUpperCase().includes("BT")
                  ).length === 0 ? (
                    <div className={styles.noDataMessage}>
                      {t("NoChemicalIndicatorSpan")}
                    </div>
                  ) : (
                    cycleDetail.indicatorsWashing &&
                    cycleDetail.indicatorsWashing
                      .filter(
                        (i) => !i.indicator.name.toUpperCase().includes("BT")
                      )
                      .map((indicator) => (
                        <div className={styles.indicatorGeneral2}>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              marginBottom: "20px",
                            }}
                          >
                            {indicator.pcD_Group ? (
                              <div className={styles.indicatorItem2}>
                                <IndicatorLabel
                                  zone={indicator.indicatorModelArea.description}
                                  readingId={indicator.readingCheWasher?.id}
                                  isChemical={true}
                                  backgroundColor={"white"}
                                  name={indicator.indicator.name}
                                  lot={indicator.lot}
                                  serial={indicator.serial}
                                  expirationDate={
                                    indicator.indicatorExpirationDate
                                  }
                                  border={true}
                                  resultCH={indicator.readingCheWasher?.result}
                                  userResultCH={
                                    indicator.readingCheWasher?.visualResult
                                  }
                                  pcd={`${indicator.pcdName} - ${indicator.pcdLot}`}
                                />
                              </div>
                            ) : (
                              <div className={styles.indicatorItem2}>
                                <IndicatorLabel
                                  zone={indicator.indicatorModelArea.description}
                                  readingId={indicator.readingCheWasher?.id}
                                  isChemical={true}
                                  backgroundColor={"white"}
                                  name={indicator.indicator.name}
                                  lot={indicator.lot}
                                  serial={indicator.serial}
                                  expirationDate={
                                    indicator.indicatorExpirationDate
                                  }
                                  border={true}
                                  resultCH={indicator.readingCheWasher?.result}
                                  userResultCH={
                                    indicator.readingCheWasher?.visualResult
                                  }
                                />
                              </div>
                            )}

                            <div className={styles.detailsBox}>
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  marginBottom: "10px",
                                }}
                              ></div>
                              {Object.keys(indicator.readingCheWasher || {})
                                .length === 0 ? (
                                <span>{t("WithoutReadingSpan")}</span>
                              ) : (
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                  }}
                                >
                                  <span>
                                    {t("ReadingNumber") || "Record number"}:{" "}
                                    {indicator.readingCheWasher?.readNumber}
                                  </span>
                                  <span>
                                    {t("DateSpan") || "Date"}:{" "}
                                    {df(
                                      indicator.readingCheWasher?.creationTest,
                                      "dateTime"
                                    )}
                                  </span>
              
                                  <span>
                                    {t("ObservationSpan") || "Observations"}:{" "}
                                    {indicator.readingCheWasher?.notes}
                                  </span>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      ))
                  )}
                </div>
              </div>
            </section>

            <section>
              <div className={styles.imageTitleContainer}>
                <img
                  src={materialImg}
                  alt="Materials"
                  className={styles.image}
                />
                <h2 className={styles.sectionTitle}>{t("MaterialsSpan")}</h2>
              </div>
              {cycleDetail.packagesWashing &&
              cycleDetail.packagesWashing.length === 0 ? (
                <p className={styles.noDataMessage}>
                  {t("WithoutPackageMaterialSpan")}.
                </p>
              ) : (
                <div className={styles.tableContainer}>
                  {cycleDetail.packagesWashing &&
                    cycleDetail.packagesWashing.map((pkgObj) => {
                      const pkg = pkgObj.packageWashing;
                      return (
                        <div className={styles.packageSection}>
                          {/* <h3 className={styles.packageTitle}>PKG-{pkg.id} {pkg.description}</h3> */}
                          {/* <div>
      <h3 className={styles.packageTitle} onClick={handleShowDetail}>
        PKG-{pkg.id} {pkg.description}
      </h3>
      {showDetail && <PackageDetail />}
          </div> */}

                          <div>
                            <h3
                              className={styles.packageTitle}
                              // onClick={() => toggleOpen(pkg.id)}
                            >
                               {pkg.packageNumber} - {pkg.description}
                              {/* {openSections[pkg.id] ? (
                                <IoIosArrowUp className={styles.arrowIcon} />
                              ) : (
                                <IoIosArrowDown className={styles.arrowIcon} />
                              )} */}
                            </h3>
                            {/* {openSections[pkg.id] && (
                              <div className={styles.additionalContent}>
                              
                
                                <div className={styles.observationSection2}>
                                  <p className={`${styles.observationTitle2}`}>
                                    Observation
                                  </p>
                                  <div className={styles.observationContainer2}>
                                    {pkg.observations ? (
                                      <p className={styles.observation2}>
                                        {pkg.observations}
                                      </p>
                                    ) : (
                                      <p className={styles.observation2}>
                                        {t("NoObservationSpan")}
                                      </p>
                                    )}
                                  </div>
                                </div>
                              </div>
                            )} */}
                          </div>
                          <table className={styles.dataTable}>
                            <thead>
                              <tr>
                                <th className={styles.th}>
                                  {t("MaterialSpan")}
                                </th>
                                <th className={styles.th}>
                                  {t("TypeOfMaterialSpan")}
                                </th>
                                <th className={styles.th}>
                                  {t("QuantitySpan")}
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {pkg.materials && pkg.materials.length > 0 ? (
                                pkg.materials.map((materialObj, index) => {
                                  const material = materialObj.material;

                                  if (!material) {
                                    return null;
                                  }

                                  return (
                                    <tr
                                      key={material.materialId || index}
                                      className={styles.trHover}
                                    >
                                      <td className={styles.td}>
                                        {" "}
                                        {material.name ||
                                          "Nombre no disponible"}
                                        {material.serial && (
                                          <div className={styles.serial}>
                                            {t("SerialSpan")}: {material.serial}
                                          </div>
                                        )}
                                        {/* <div className={styles.iconWrapper}>
                     { <div className={styles.icon}></div>}
                       </div> */}
                                        {/* method !== materialMethod */}
                                      </td>
                                      <td className={styles.td}>
                                        {material.materialType.name || "N/A"}
                                      </td>
                                      <td className={styles.td}>
                                        {materialObj.quantity || 0}
                                      </td>
                                    </tr>
                                  );
                                })
                              ) : (
                                <tr>
                                  <td colSpan="3" className={styles.td}>
                                    {t("NoMaterialSpan")}{" "}
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      );
                    })}
                </div>
              )}
            </section>
          </div>
          <div className={styles.containerRight}>
            <section>
              <h2 className={styles.titleImage}>{t("ImageSpan")}</h2>

              {cycleDetail.ticketWasher ? (
                <div className={styles.imgContainer}>
                  <img
                    src={cycleDetail.ticketWasher}
                    alt="No available"
                    className={styles.ticketImage}
                    onClick={handleImageClick}
                  />
                </div>
              ) : (
                <div className={styles.imgContainer2}>
                  <h2 className={styles.titleImage}>
                    {t("BlankEntry12") || "The ticket wasn't loaded"}
                  </h2>
                </div>
              )}
              {isModalOpen && (
                <ImageModal
                  imageSrc={cycleDetail.ticketWasher}
                  onClose={handleCloseModal}
                />
              )}
            </section>
          </div>
        </div>
        <div>
          {/* <ButtonQ
            caption={t("DownloadAsPDF", locale)}
            onClick={() => downloadPdf(cycleId)}
          /> */}
          {/* {loading &&  
         <p style={{ fontWeight: 'bold', fontSize: '15px', marginLeft: '30px' }}>
          Loading PDF...
        </p>}   */}
          <ModalLoading open={modalLoading} />
          {showReport && (
            <ReportModal
              htmlContent={report}
              onClose={handleCloseModalReport}
            />
          )}
        </div>

        {/* <PDFDownloadLink
        document={
          <BatchRecordPdf
            cycleDetail={cycleDetail}
            packages={packages}
            getResultBackgroundColor={getResultBackgroundColor}
            getResultText={getResultText}
          />
        }
        fileName={`BatchRecord-${cycleDetail.cicleNumber}.pdf`}
      >
        {({ blob, url, loading, error }) =>
          loading ? "Generando PDF..." : "Descargar PDF"
        }
      </PDFDownloadLink> */}

        {/* <BatchRecordPdf contentId="report-content"/> */}
      </div>
      <ButtonQ onClick={generatePDF}>{t("DownloadAsPDF")}</ButtonQ>
      
    </PageContainer>
  );
}
